import { Suspense } from 'react';

import { Navigate, Route } from 'react-router-dom';

import { PageSkeleton } from '@gw/ui';
import { FeatureFlagGuard } from '@/components/routes/FeatureFlagGuard';
import { lazyWithRetry } from '@/lib/lazyWithRetry.util';

// ============================================================================
// /consultant/* routes. Mounted inside ProtectedRoute → TOSGuard → AppLayout
// in App.tsx; the guards live on that shared scaffold, not here.
// ============================================================================

// GW-3061: Consultant RFI pages
const ConsultantRFIListPage = lazyWithRetry(() =>
  import('@/pages/consultant/ConsultantRFIListPage').then((m) => ({
    default: m.ConsultantRFIListPage,
  }))
);
const ConsultantRFIDetailPage = lazyWithRetry(() =>
  import('@/pages/consultant/ConsultantRFIDetailPage').then((m) => ({
    default: m.ConsultantRFIDetailPage,
  }))
);

export const consultantRoutes = (
  <>
    {/* GW-3061: Consultant RFI routes. GW-8665: gated behind services_marketplace. */}
    <Route
      path="/consultant/rfis"
      element={
        <FeatureFlagGuard flagName="services_marketplace" fallbackRoute="/">
          <Suspense fallback={<PageSkeleton />}>
            <ConsultantRFIListPage />
          </Suspense>
        </FeatureFlagGuard>
      }
    />
    <Route
      path="/consultant/rfis/:rfiId"
      element={
        <FeatureFlagGuard flagName="services_marketplace" fallbackRoute="/">
          <Suspense fallback={<PageSkeleton />}>
            <ConsultantRFIDetailPage />
          </Suspense>
        </FeatureFlagGuard>
      }
    />
    {/* GW-8058: /consultant/profile replaced by /settings/consultant-profile
        (target IA, GW-8043/D11) */}
    <Route
      path="/consultant/profile"
      element={<Navigate to="/settings/consultant-profile" replace />}
    />
  </>
);
